import classNames from 'classnames'
import React from 'react'

import type { PrefilledButtonProps } from 'shared-libs/components/ui2/fields/field-ui/prefilled-button/prefilled-button-props'

import './_prefilled-button.scss'

type WebPrefilledButtonProps = Omit<PrefilledButtonProps, 'style' | 'textStyle'> & {
  style?: React.CSSProperties
  textStyle?: React.CSSProperties
  className?: string
}

export function UI2PrefilledEditButton(props: WebPrefilledButtonProps) {
  const { onPress, style, textStyle, className, text } = props
  return (
    <button
      type='button'
      className={classNames('ui2-prefilledButton', 'ui2-prefilledButton--edit', className)}
      onClick={onPress}
      style={style}
    >
      <span className='ui2-prefilledButton-text' style={textStyle}>{text ?? 'Edit'}</span>
    </button>
  )
}

export function UI2PrefilledCancelButton(props: WebPrefilledButtonProps) {
  const { onPress, style, textStyle, className, text } = props
  return (
    <button
      type='button'
      className={classNames('ui2-prefilledButton', 'ui2-prefilledButton--cancel', className)}
      onClick={onPress}
      style={style}
    >
      <span className='ui2-prefilledButton-text' style={textStyle}>{text ?? 'Cancel'}</span>
    </button>
  )
}
